import { render } from "./FilterSubSegments.vue?vue&type=template&id=595a9a90"
import script from "./FilterSubSegments.vue?vue&type=script&lang=js"
export * from "./FilterSubSegments.vue?vue&type=script&lang=js"
script.render = render

export default script